/**
 * Footer credit: Promang storefront / CMS platform.
 * @param {{ variant?: "light" | "dark" }} props
 */
export function PromangPowered({ variant = "light" }) {
  if (variant === "dark") {
    return (
      <a
        href="https://promang.no"
        target="_blank"
        rel="noopener noreferrer"
        className="powered-by group hover:border-[var(--airon)]/40 transition-colors"
      >
        <span>Powered by</span>
        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-[var(--airon)] text-xs font-bold text-white">
          P
        </span>
        <span className="text-sm font-medium text-[#D6E0EA] group-hover:text-white" style={{ fontFamily: "var(--display)" }}>
          Promang
        </span>
      </a>
    );
  }

  return (
    <a
      href="https://promang.no"
      target="_blank"
      rel="noopener noreferrer"
      className="group inline-flex max-w-full flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-2xl border border-slate-200/90 bg-gradient-to-br from-white/95 to-slate-50/90 px-4 py-2.5 text-slate-600 shadow-sm ring-1 ring-slate-900/5 transition-all duration-300 hover:border-sky-200/80 hover:shadow-md hover:ring-sky-500/10"
    >
      <span className="text-[11px] font-medium uppercase tracking-[0.12em] text-slate-500 sm:text-xs">
        Powered by
      </span>
      <span className="flex items-center gap-2">
        <span
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-sky-500 to-indigo-600 text-sm font-bold text-white shadow-inner transition-transform duration-300 group-hover:scale-105"
          aria-hidden
        >
          P
        </span>
        <span className="text-sm font-semibold tracking-tight text-slate-800 transition-colors group-hover:text-sky-700">
          Promang
        </span>
      </span>
    </a>
  );
}
